import {createStrokeSVG} from './TEMPLATE'

// tabler: menu-2
export const Menu_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: ['M4 6l16 0', 'M4 12l16 0', 'M4 18l16 0'],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
